module.exports = __webpack_public_path__ + "img/Co2red.0ec377c6.png";